<template>
  <div class="work base-pad">
    <div class="title">
      <img :src="zh_en == 'zh' ? STATICURL + bgimg.work_bgimg : STATICURL + work_bgimg_en"
        style="width: 100%;height: 100%;" alt="">

    </div>


    <div class="content">

      <img src="../static/images/workBack.png" style="height: 100%; position: absolute;top: 0;left: 0;" alt="">

      <div class="detail">

        <div class="titlebox">
          <div style="color: #8a2e26;font-size: 28px;font-weight: bold;"> {{ zh_en == 'zh' ? '商务合作' : 'Business Cooperation '
            }}</div>


          <img src="@/static/images/cultureTitile.png" style="width: 100%;position: absolute;bottom: 0;left: 0;"
            mode="widthFix" />
        </div>

        <div class="contentbox" style="padding: 40px;box-sizing: border-box;">






          <div style="display: flex;align-items: center;">
            <div style="width: 6px;height: 28px;background-color: #8a2e26;margin-right: 10px;"></div>

            <div style="color: #8a2e26;font-size: 22px;font-weight: 600;text-align: left;">{{ cooperation_info.title }}

            </div>
          </div>
          <!-- cooperation_info -->
          <div v-html="cooperation_info.content"></div>
        </div>



      </div>

    </div>

    <HomeFooter />
  </div>
</template>

<script>
import HomeFooter from '@/components/HomeFooter.vue';
import {
  get_cooperation_info
} from "@/api/api";
export default {
  data() {
    return {
      activityIndex: 0,
      cooperation_info: '',
    }
  },
  components: {
    HomeFooter
  },
  mounted() {
    this.get_cooperation_info()
  },
  methods: {
    change(e) {
      this.activityIndex = e
    },
    get_cooperation_info() {
      get_cooperation_info().then(res => {
        this.cooperation_info = res
      })
    }
  }

}
</script>


<style lang="less" scoped>
.default {
  font-size: 15px;
  padding: 2px 0;
  display: flex;
  align-items: center;
  margin-left: 35px;
}

.activity {
  font-size: 17px;
  color: #8A2E26;
  border-bottom: 1px solid #8A2E26;
}

.content {
  width: 100%;
  padding: 48px;
  box-sizing: border-box;
  position: relative;

  .detail {
    .titlebox {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      padding-bottom: 30px;
    }

    width: 60%;
    margin: 0 auto;
  }
}

.work {}

.title {
  width: 100%;
  height: 360px;
  background-color: #d3dce6;

}
</style>